import React, { useState, useEffect } from 'react';
import Slider, {slickNext} from 'infinite-react-carousel';
import SliderProduct from "../menu-categories/slider-view/SliderProduct";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { APP_PREFIX_PATH } from 'configs/AppConfig';
import './pinned.css';


const PinnedBox = () => {
    const { theme: { locale }, fetchedData: { pinnedBox } } = useSelector(state => state);
    const [sliderVisible, setSliderVisible] = useState(false);

    useEffect(() => {
        setSliderVisible(true);
    }, [])

    return (
        <div>
            {pinnedBox[0]?.id && pinnedBox?.map((pinned, index) => <div key={index}>
                <h3>{locale === 'en' ? pinned?.titleEng : pinned?.titleAr}</h3>
                {sliderVisible &&
                    <Slider
                        shift={10}
                        slidesToShow={2}
                        autoplay={true}
                        autoplaySpeed={2000}
                        className='pinnedBox-carousel'
                    >
                        {pinned?.products?.map((item, index) => <Link to={APP_PREFIX_PATH + '/products/' + item?.id} key={index}>
                            <SliderProduct product={item} locale={locale} />
                        </Link>)}
                    </Slider>
                }
            </div>)}
        </div>
    )
}

export default PinnedBox;